var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0538 15.2983C35.7164 14.0466 34.7224 13.0609 33.4604 12.7263C31.1728 12.1184 22 12.1184 22 12.1184C22 12.1184 12.8273 12.1184 10.5397 12.7263C9.27765 13.0609 8.28368 14.0466 7.94632 15.2983C7.33337 17.567 7.33337 22.3005 7.33337 22.3005C7.33337 22.3005 7.33337 27.034 7.94632 29.3028C8.28368 30.5544 9.27765 31.4992 10.5397 31.8337C12.8273 32.4416 22 32.4416 22 32.4416C22 32.4416 31.1728 32.4416 33.4604 31.8337C34.7224 31.4992 35.7164 30.5544 36.0538 29.3028C36.6667 27.034 36.6667 22.3005 36.6667 22.3005C36.6667 22.3005 36.6667 17.567 36.0538 15.2983ZM19 26.5982V18.0029L26.6667 22.3006L19 26.5982Z",
    fill: "#00000099"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.2650a53125577551094466edf310877b.svg";
export { ForwardRef as ReactComponent };